// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const appearanceSections: PaneSection[] = [
  {
    section: 'intro',
    title: 'Appearance',
    body: 'Make Ping look the way you like. Everything you change here applies right away so you can see it live.',
  },
  {
    section: 'theme',
    title: 'Light or dark',
    body: 'Pick a light theme, a dark theme, or let Ping follow your system setting and switch automatically.',
  },
  {
    section: 'background',
    title: 'Chat background',
    body: 'Choose the backdrop drawn behind your chat threads, from plain to a soft gradient.',
  },
  {
    section: 'layout',
    title: 'Message layout',
    body: 'Show each message in its own bubble, or use the compact layout that stacks messages under one avatar.',
  },
  {
    section: 'accent',
    title: 'Accent color',
    body: 'Set the highlight color used for links, selections, and primary buttons across the app.',
  },
  {
    section: 'zoom',
    title: 'Zoom scale',
    body: 'Scale the whole interface up or down. Handy if you want everything a little bigger or more compact.',
  },
];
